/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Alert, Text, VFlow } from 'bold-ui'

import {
  ConsultaSeguimentoPerguntasDiff,
  ConsultaSeguimentoPerguntasDiffProps,
} from '../components/ConsultaSeguimentoPerguntasDiff'

export function ConsultaSeguimentoPerguntasDiffModalBody(props: Readonly<ConsultaSeguimentoPerguntasDiffProps>) {
  const { perguntasAnteriores, perguntasAtuais, perguntasObrigatorias, perguntasComRespostas } = props

  return (
    <VFlow style={styles.root}>
      <Alert type='info' inline styles={{ wrapper: styles.alert }}>
        As respostas já registradas serão mantidas, a não ser que a pergunta tenha sido removida na alteração.
      </Alert>
      <ConsultaSeguimentoPerguntasDiff
        perguntasAnteriores={[...perguntasAnteriores].sort((a, b) => a.localeCompare(b))}
        perguntasAtuais={[...perguntasAtuais].sort((a, b) => a.localeCompare(b))}
        perguntasObrigatorias={perguntasObrigatorias}
        perguntasComRespostas={perguntasComRespostas}
      />
      <Text>
        <Text color='danger' fontWeight='bold'>
          *{' '}
        </Text>
        Pergunta obrigatória porque a criança falhou no M-Chat-R.
      </Text>
    </VFlow>
  )
}

const styles = {
  root: css`
    width: 44.875rem;
  `,
  alert: css`
    width: 100%;
  `,
}
